import {forwardRef} from 'react'

import {twMerge} from '@sdox/utils'

import type {ClassNameValue} from 'tailwind-merge'
import type {ComponentProps} from 'react'

export type Variants = 'legacy' | 'flat' | 'outline'

export interface InputProps extends Omit<ComponentProps<'input'>, 'value'> {
  className?: string
  name?: string
  value?: string
  hasError?: boolean
  variant?: Variants
}

const variants: Record<Variants, ClassNameValue> = {
  'legacy': 'caret-sdox-accent ring-1 ring-inset ring-sdox-slate focus:ring-2 focus:ring-inset focus:ring-sdox-primary',
  'flat': '',
  'outline': 'border border-interactive-outline-default-default/40 text-interactive-glyph-default-primary',
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  hasError,
  className,
  value,
  name,
  variant = 'legacy',
  ...restProps
}, ref) => (
  <input
    ref={ref}
    name={name}
    value={value}
    className={twMerge(
      'rounded-sm border-0 p-2 outline-none focus:outline-none',
      hasError ? 'text-red-500 caret-red-500 ring-red-500 placeholder:text-red-500 focus:ring-red-500' : '',
      variants[variant],
      className,
    )}
    {...restProps}
  />
),
)
